import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAllCoinNews } from '../../hooks/useAllCoinNews';
import { useLanguage } from '../../contexts/LanguageContext';
import { SkeletonNewsfeed } from '../SkeletonTradeRow/SkeletonTradeRow';
import './NewsfeedPanel.css';

function formatTimeShort(date) {
  const seconds = Math.floor((Date.now() - new Date(date)) / 1000);
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h`;
  return `${Math.floor(seconds / 86400)}d`;
}

function NewsfeedPanel() {
  const { t } = useTranslation();
  const { language, localizedPath } = useLanguage();
  const navigate = useNavigate();
  const { news, loading, isConnected } = useAllCoinNews();

  const getNewsText = (item) => {
    if (item.translations && item.translations[language]) return item.translations[language];
    return item.title || item.text || '';
  };

  return (
    <div className="card mb-3">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div className="card-title mb-0">
          <div className="info-hover">
            <p className="title-with-tooltip">📰 {t('news.title')}</p>
            <div className="tooltip-card">
              <div className="card-body">
                <h5>{t('news.title')}</h5>
                <span className="divider"></span>
                <p>{t('news.tooltip')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body scroll h-sm">
        {loading && <SkeletonNewsfeed count={5} />}

        {!loading && news.length === 0 && (
          <p className="text-muted small text-center py-4">{t('news.noNews')}</p>
        )}

        {!loading && news.length > 0 && (
          <div className="news-list">
            {news.slice(0, 30).map((item) => (
              <div
                key={item.guid || item._id}
                className="news-item"
              >
                <div className="news-meta-row">
                  <span className="news-source">{(item.source || item.chatTitle || 'News').replace('Crpyto', 'Crypto')}</span>
                  <span className="news-dot">·</span>
                  <span className="news-time">{formatTimeShort(item.pubDate || item.timestamp)}</span>
                  {item.coins && item.coins.length > 0 && item.coins.map((coin) => (
                    <span key={coin} className="news-tag" onClick={() => navigate(localizedPath(`/price/${coin}`))}>#{coin}</span>
                  ))}
                </div>
                <p className="news-title">{getNewsText(item)}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default NewsfeedPanel;
